var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37506 4.18542C4.86132 4.48202 4.46069 4.89606 4.1854 5.37379C3.9786 5.73268 3.52001 5.85597 3.16111 5.64917C2.80222 5.44236 2.67893 4.98377 2.88574 4.62488C3.28916 3.92477 3.87686 3.31835 4.62506 2.88638C6.89694 1.5747 9.802 2.35311 11.1137 4.625C12.4254 6.89689 11.6469 9.80194 9.37506 11.1136C7.10317 12.4253 4.19811 11.6469 2.88643 9.375C2.68199 9.02089 2.52795 8.6504 2.4226 8.27223C2.31144 7.87321 2.5448 7.45963 2.94382 7.34848C3.34284 7.23732 3.75642 7.47068 3.86758 7.8697C3.93936 8.12739 4.04462 8.38103 4.18547 8.625C5.08294 10.1795 7.0706 10.712 8.62506 9.81458C10.1795 8.91712 10.7121 6.92945 9.81464 5.375C8.91717 3.82055 6.92951 3.28795 5.37506 4.18542Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9697 14.0303L8.9697 10.0303L10.0304 8.96967L14.0304 12.9697C14.3232 13.2626 14.3232 13.7374 14.0304 14.0303C13.7375 14.3232 13.2626 14.3232 12.9697 14.0303Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4e4b3e78.svg";
export { ForwardRef as ReactComponent };